import Feeder from "./Feeder";
import EpgDataManager from "../EpgDataManager";
import { CHANNELS_DB_TABLE, EVENTS_DB_TABLE } from "../Constans";
import { showEpgUpdateProgress } from "../helpers/Utils";

class JsFeeder extends Feeder{
    constructor(){
        super();
    }

    async updateOfflineEpg(urls=[], updateProgressMessageType){
        try{
            let percentage = 0, clearResult = null, channelsResult = null, eventsResult = null;
            clearResult = await new EpgDataManager().clearDB();
            for(let i=0; i<urls.length; i++){
                percentage = ( (i+1) * 100) / urls.length;
                if(i===urls.length-1)
                    percentage=99;
                showEpgUpdateProgress(updateProgressMessageType, percentage);
                let epgResponse = await fetch(urls[i]);
                epgResponse = await epgResponse.json();
                epgResponse= epgResponse.response;
                channelsResult = await new EpgDataManager().insert(epgResponse.channelsEvents, CHANNELS_DB_TABLE);
                eventsResult = await new EpgDataManager().insert(epgResponse.events, EVENTS_DB_TABLE);
                epgResponse = null;
            }
            return new Promise(resolve=>resolve(channelsResult && eventsResult));
        }
        catch(e){
            return new Promise(resolve=>resolve(false));
        }
    }
}

export default JsFeeder;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/feeders/JsFeeder.js